export default __webpack_public_path__ + "static/media/octopy-rooms.c9519330.svg";